import { z } from "zod";

export const existingAmbassadorSignupSchema = z
  .object({
    email: z
      .string()
      .min(1, "Email is required")
      .email("Please enter valid email address"),
    password: z.string().min(1, "Password is required"),
    confirmPassword: z.string().min(1, "Please confirm your password"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Password do not match",
    path: ["confirmPassword"],
  });

export type ExistingAmbassadorSignupFormData = z.infer<
  typeof existingAmbassadorSignupSchema
>;

export const defaultValues: ExistingAmbassadorSignupFormData = {
  email: "",
  password: "",
  confirmPassword: "",
};

export const PAGE_CONFIG = {
  TITLE: "Create your account",
} as const;
